import * as React from 'react';
import './Tooltip.css';

interface Props {
    message: string;
    enabled: boolean;
    size?: 'small' | '';
}

class Tooltip extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className={`tooltip ${this.props.size} ${this.props.enabled ? 'enabled' : ''}`}>
                {this.props.children}
                <span className="tooltip-text">{this.props.message}</span>
            </div>
        );
    }
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/view/tooltip/Tooltip.tsx